import {
  REQUEST_SEARCH_INCIDENT_TYPES,
  REQUEST_SEARCH_INCIDENT_TYPES_SUCCESS,
  REQUEST_SEARCH_INCIDENT_TYPES_FAIL
} from "./actionTypes";

import { getIncidentTypesUrl } from "../../config/apiConfig";
import { parseFetchOptions } from "../user/actions";
import errors from "../../utils/errors";

// Cases
const requestIncidentTypes = () => ({
  type: REQUEST_SEARCH_INCIDENT_TYPES
});

const requestIncidentTypesSuccess = payload => ({
  type: REQUEST_SEARCH_INCIDENT_TYPES_SUCCESS,
  payload
});

const requestIncidentTypesFail = payload => ({
  type: REQUEST_SEARCH_INCIDENT_TYPES_FAIL,
  payload
});

// eslint-disable-next-line import/prefer-default-export
export const getIncidentTypes = () => (dispatch, getState) => {
  const { isLoading, data } = getState().incidentTypes;
  if (isLoading || data) return;

  dispatch(requestIncidentTypes());

  dispatch(
    parseFetchOptions(async options => {
      const response = await fetch(getIncidentTypesUrl, {
        method: "GET",
        headers: options.headers
      }).catch(error => {
        dispatch(requestIncidentTypesFail(error));
      });

      if (response && response.ok) {
        const data = await response.json();
        dispatch(requestIncidentTypesSuccess(data));
      } else {
        dispatch(requestIncidentTypesFail(errors.responseError(response)));
      }
    })
  );
};
